import { createApp } from 'vue';
import i18n from '../i18n';
import App from './App.vue';

(() => {
    const container = document.getElementById('vue-points-of-sale');
    if (container) {
        const configData = container.getAttribute('data-config');
        let meta = null;
        if (configData) {
            try {
                meta = JSON.parse(configData);
            } catch (e) {
                console.error('Failed to parse config data:', e); // eslint-disable-line no-console
            }
        }
        const app = createApp(App, { meta });

        app.use(i18n);
        app.mount(container);
    }
})();
